import { Group, Tooltip } from "@mantine/core";
import { IconAlertTriangleFilled } from "@tabler/icons-react";
import type { MRT_Column, MRT_RowData } from "mantine-react-table-open";
import { TruncatedHeader } from "../../../TruncatedHeader";

interface HeaderWithWarningProps<T extends MRT_RowData> {
  column: MRT_Column<T>;
  label: string;
  color?: string;
}

function HeaderWithWarning<T extends MRT_RowData>({
  column,
  label,
  color = "var(--mantine-color-warning-filled)"
}: HeaderWithWarningProps<T>) {
  return (
    <Group align="flex-start" gap="xs" justify="flex-end" wrap="nowrap">
      <Tooltip label={label} multiline position="left" w={220}>
        <IconAlertTriangleFilled
          color={color}
          size={20}
          style={{ flexShrink: 0 }}
        />
      </Tooltip>
      <TruncatedHeader>{column.columnDef.header}</TruncatedHeader>
    </Group>
  );
}

export { HeaderWithWarning };
